import React, { useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { List, Input } from 'antd';
import { useTranslation } from 'react-i18next';

function CountryCodeSelect({
  onSelect,
  countryCodes,
}) {
  const { t } = useTranslation();

  const renderItem = useCallback(
    item => <List.Item onClick={() => onSelect(item.value)}>{item.label}</List.Item>,
    [onSelect],
  );

  const keyExtractor = useCallback(item => item.key, []);

  const [searchText, setSearchText] = useState('');

  const trimmedSearchText = searchText.trim();
  const displayList = useMemo(
    () => (trimmedSearchText === ''
      ? countryCodes
      : countryCodes.filter(({ label }) => (
        label.toUpperCase().includes(trimmedSearchText.toUpperCase())))),
    [trimmedSearchText, countryCodes],
  );

  const setSearchTextFromEvent = useCallback(
    e => setSearchText(e.target.value),
    [],
  );

  return (
    <div>
      <h3>{t('user.countryCode')}</h3>
      <Input
        placeholder={t('actions.search')}
        onChange={setSearchTextFromEvent}
        allowClear
      />
      <List
        size="small"
        bordered
        dataSource={displayList}
        renderItem={renderItem}
        rowKey={keyExtractor}
      />
    </div>
  );
}

CountryCodeSelect.propTypes = {
  onSelect: PropTypes.func.isRequired,
  countryCodes: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};

export default CountryCodeSelect;
